const backgroundStyles = {
  gradientWithCurves1: 'Gradient With Curves 1',
  gradientWithCurves2: 'Gradient With Curves 2',
  gradientWithCurves3: 'Gradient With Curves 3',
  gradientWithCurves1Portrait: 'Gradient With Curves 1 Portrait',
  gradientWithCurves2Portrait: 'Gradient With Curves 2 Portrait',
  gradientWithCurves1Square: 'Gradient With Curves 1 Square',
  gradientWithCurves2Square: 'Gradient With Curves 2 Square',
  gradientWithCurves3Square: 'Gradient With Curves 3 Square',
  gradientWithCurves4Square: 'Gradient With Curves 4 Square',
  gradientWithCurves5Square: 'Gradient With Curves 5 Square',
  gradientWithCurves6Square: 'Gradient With Curves 6 Square',
  gradientWithCurves7Square: 'Gradient With Curves 7 Square',
  gradientWithCurves8Square: 'Gradient With Curves 8 Square',
  gradient1: 'Gradient 1',
  gradient2: 'Gradient 2',
  subtleGradient: 'Subtle Gradient',
  midnightGradient: 'Midnight',
  productImageTabs1: 'Product Image Tabs 1',
  glacierGradient: 'Glacier Gradient',
  skyBlue: 'Sky Blue',
}

export default backgroundStyles
